<template>
  <custom-data-chips
    :label="label"
    :color="technician.scheduled ? 'success--text' : ''"
    :value="technician.full_name"
    :loading="loading"
    @click="$emit('click', technician)"
  >
    <custom-simple-table
      :item="transformedItem"
      i18-path="tech_search.fields"
      :table-keys="technicianTableKeys"
    />
  </custom-data-chips>
</template>

<script>
import CustomDataChips from '@/components/displays/CustomDataChips';
import CustomSimpleTable from '@/components/displays/CustomSimpleTable';
import { generateMessage } from '@/utils/i18n';
import Technician from '@/store/modules/technicians/model';

export default {
  name: 'CustomTechnicianChips',
  components: { CustomDataChips, CustomSimpleTable },
  methods: {
    generateMessage,
  },
  props: {
    label: { type: String, required: true },
    loading: { type: Boolean, required: false },
    technician: { type: Technician, required: true },
  },
  computed: {
    technicianTableKeys() {
      const keys = ['entity_id', 'entity_name', 'phone'];
      if (this.technician.company_subcontractor_name) {
        keys.splice(1, 0, 'company_subcontractor_name', 'activity_field');
      }
      return keys;
    },
    transformedItem() {
      return {
        ...this.technician,
        phone: `(${this.technician.phone_type}) ${
          this.technician.phone && this.technician.phone.slice(0, 5) !== 'EMAIL'
            ? this.technician.phone
            : this.technician.email
        }`,
      };
    },
  },
};
</script>
